<template lang="pug">
.box.cell-menu-action
    .box-header.b-b
        h3 Update Cell
    .box-body
        template(v-if="cell.action_type == 'product'")
            div.form-group
                label Product
                multiselect(
                    v-model="cell.action",
                    :internal-search="false",
                    :options="productList",
                    :option-height="104",
                    :limit="10",
                    :loading="onLoading('fetch-products')", 
                    :show-labels="false",
                    placeholder="Type to search",
                    label="name",
                    track-by="id",
                    @search-change="getProducts"
                )
                    template(slot="option", slot-scope="props")
                        .row
                            .col-xs-2
                                img.img-responsive(:src="props.option.media_urls.length > 0 ? props.option.media_urls[0].s512 : '/img/slurp-500.png'", alt="Product image")
                            .p-l-0.col-xs-10
                                span.option__title {{ props.option.name }}
                                br
                                small.text-ellipsis {{ props.option.description }}

        template(v-else-if="cell.action_type == 'variant'")
            div.form-group
                label Variant
                multiselect(
                    v-model="cell.action",
                    :internal-search="false",
                    :options="variantList",
                    :option-height="104",
                    :limit="10",
                    :loading="onLoading('fetch-variants')", 
                    placeholder="Type to search",
                    label="name",
                    track-by="id",
                    @search-change="getVariants",
                    :show-labels="false",
                    :custom-label="variantName"
                )
                    template(slot="option", slot-scope="props")
                        .row
                            .col-xs-2
                                img.img-responsive(
                                    :src="props.option.product.media_urls.length > 0 ? props.option.product.media_urls[0].s512 : '/img/slurp-500.png'",
                                    alt="Product image"
                                )
                            .p-l-0.col-xs-10
                                span.option__title {{ props.option.product.name }}
                                br
                                span._500.text-muted {{ props.option.name }}

        template(v-else-if="cell.action_type == 'promotion'")
            div.form-group
                label Promotion
                multiselect(
                    v-model="cell.action",
                    :internal-search="false",
                    :options="promotionList",
                    :option-height="104",
                    :limit="10",
                    :loading="onLoading('fetch-promotions')", 
                    placeholder="Type to search",
                    label="name",
                    track-by="id",
                    @search-change="getPromotions",
                    :show-labels="false"
                )
                    template(slot="option", slot-scope="props")
                        .row
                            .col-md-12
                                span.option__title {{ props.option.name }}
                                br
                                strong {{ promotionType(props.option) }}

        template(v-else-if="cell.action_type == 'group'")
            div.form-group
                label Display group
                multiselect(
                    v-model="cell.action",
                    :options="groupList",
                    placeholder="Select display group",
                    label="name",
                    track-by="id",
                )

        div.form-group.m-b-0
            color-picker(v-model="cell.color")
    
    .box-footer.b-t
        button.btn.btn-sm.btn-block.white(@click="updateCell", :disabled="cell.action === null") Apply
</template>

<script>
import { OrderLayoutEvent } from './order-layout-bus';
import { mapGetters, mapActions } from 'vuex';
import colorPicker from './order-layout-color-picker.vue';
import PromotionTypes from '@js/store/promotion-types';

export default {
    components: {
        colorPicker,
    },

    data() {
        return {
            cell: {
                color: '',
                action: null,
            },
            productList: [],
            variantList: [],
            promotionList: [],
        };
    },

    computed: {
        ...mapGetters('orderLayout', [
            'orderLayout',
            'groupList',
            'activePage',
            'getPageCellByGrid',
            'selectedGrid',
        ]),
    },

    mounted() {
        OrderLayoutEvent.$on('edit-cell', grid => {
            const { page_id, x, y } = grid;
            const cell = this.getPageCellByGrid(page_id, x, y, true);
            this.setCell(cell);
        });

        this.getProducts(null);
        this.getVariants(null);
        this.getPromotions(null);
    },

    methods: {
        ...mapActions('product', ['fetchProducts']),
        ...mapActions('variant', ['fetchVariants']),
        ...mapActions('promotion', ['fetchPromotions']),
        ...mapActions('orderLayout', [
            'setOrCreatePageCell',
            'setSelectedGrid',
        ]),

        getProducts: _.debounce(async function(query) {
            this.startLoading('fetch-products');
            const { data } = await this.fetchProducts({
                query,
                limit: 15,
                outlet_id: this.orderLayout.outlet_id,
            });
            this.productList = data;
            this.endLoading('fetch-products');
        }, 500),

        getVariants: _.debounce(async function(query) {
            this.startLoading('fetch-variants');
            const { data } = await this.fetchVariants({
                query,
                limit: 15,
                outlet_id: this.orderLayout.outlet_id,
            });
            this.variantList = data;
            this.endLoading('fetch-variants');
        }, 500),

        getPromotions: _.debounce(async function(query) {
            this.startLoading('fetch-promotions');
            const { data } = await this.fetchPromotions({
                query,
                limit: 15,
                outlet_id: this.orderLayout.outlet_id,
            });
            this.promotionList = data;
            this.endLoading('fetch-promotions');
        }, 500),

        setCell(cell) {
            this.cell = Object.assign({}, cell);
        },

        updateCell() {
            this.cell.action_id = this.cell.action.id;
            this.setOrCreatePageCell(this.cell);
            this.setSelectedGrid();
        },

        variantName(variant) {
            return `${variant.product.name} ${variant.name}`;
        },

        promotionType(promotion) {
            let type = PromotionTypes.find(t => t.value === promotion.type);
            return type ? type.name : 'Unknown';
        },
    },
};
</script>

<style lang="scss" scoped>
label {
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/order-layout/order-layout-update-cell.vue